// src/pages/TemplatePage.jsx

// --- React Hooks & Router Imports ---
import React, { useState, useEffect, useRef, } from 'react';
// useNavigate is typically used for specific page logic, so it's commented out
// import { useNavigate } from 'react-router-dom';

import { useLocation } from 'react-router-dom';

import Box from '@mui/material/Box'; // Import Box for responsive sx prop




//REFACTOR
import './style/style_centennial.css';














// --- Component Imports ---
import Navbar from './Navbar'; // Ensure correct path to Navbar
// If you use these components on every page, keep them. Otherwise, import them per page.
// import ResponsiveSection from '../components/ResponsiveSection';
// import CollapsibleSection from '../components/CollapsibleSection';
// import CollapsibleSectionImgRight from '../components/CollapsibleSectionImgRight';
// import GoogleMapEmbed from '../components/GoogleMapEmbed';
// import ButtonsComponent from '../components/ButtonsComponent';

// --- Common Asset Imports (for background, etc.) ---
import BACKGROUND_IMAGE from 'assets/background.jpg';
// If your pages will have a consistent logo at the top or in a banner, import it here.
// Otherwise, import page-specific logos in their respective page files.
// import WONDER_MISSION_LOGO_LARGE from '../assets/wonder_mission_logo.png';
import rocketIcon from 'assets/rocket-icon.png'; // Only if StyledMissionList is used globally

// --- Styling Imports ---
import styled from 'styled-components'; // For styled-components
import 'fonts/font.css'; // Global font styles


import FadeInSectionText from 'components/ui/FadeInSectionText'

// --- NEW: Import styles from the dedicated style file ---
import {
    colors,
    pageContainerStyles,
    footerStyles,
    introBannerStyles,
    introBannerStyles2,
    introHeadingStyles,
    introSubHeadingStyles,
    introSubHeadingStyles2,
    outroQuoteStyle,
    listItemStyles, // For plain ul/li styles
    StyledMissionList, // For rocket list
    StyledMissionListItem, // For rocket list items

    // testHeadingStyles,
} from 'styles/PageStyles';

import PageWrapper from './PageWrapper'; // Import the new wrapper

// import SocialLinksBar from '../components/widgets/SocialLinksBar'


// import CHARLES_SLATKIN_IMAGE_2 from '../assets/charles-slatkin-boy.jpg'
// import CHARLES_SLATKIN_SIGNATURE from '../assets/charles-signature.png'

import GODDARD_ROCKET_LAB from 'assets/robert-goddard-rocket-lab.jpg'

import ROBERT_GODDARD_STANDING_ROCKET from 'assets/goddard-standing-by-rocket.jpg'; // Robert Goddard standing by rocket






import IMG_03 from 'assets/robert_goddard/03_rgtv-carl-sagan-viking-pichi-300x300.jpg'
import IMG_04 from 'assets/robert_goddard/04_rgtv-deep-space-one-pichi-300x300.jpg'
import IMG_05 from 'assets/robert_goddard/05_rgtv-goddard-pichi-300x300.jpg'
import IMG_06 from 'assets/robert_goddard/06_rgtv-schematic-pichi-300x300.jpg'
import IMG_07 from 'assets/robert_goddard/07_legacy-goddard-pichi-300x300.jpg'
import IMG_08 from 'assets/robert_goddard/08_legacy-goddard-space-flight-pichi-300x300.jpg'
import IMG_09 from 'assets/robert_goddard/09_legacy-james-webb-telescope-pichi-300x300.jpg'
import IMG_10 from 'assets/robert_goddard/10_legacy-launch-site-obelisk-pichi-300x300.jpg'
import IMG_11 from 'assets/robert_goddard/11_wright-brothers-pichi-300x300.jpg'
import IMG_12 from 'assets/robert_goddard/12_goodard-rocket-smaller-pichi-300x300.jpg'
import IMG_13 from 'assets/robert_goddard/13_buzz-aldrin-salute-pichi-300x300.jpg'


import IMG_14 from 'assets/robert_goddard/14_goddard-rocket-launch-illustration-pichi.jpg'













// // --- Custom Hook for Responsive Styling (Keep if used globally) ---
// const useIsMobile = (breakpoint = 768) => {
//     const [isMobile, setIsMobile] = useState(window.innerWidth < breakpoint);

//     useEffect(() => {
//         const checkMobile = () => {
//             setIsMobile(window.innerWidth < breakpoint);
//         };

//         window.addEventListener('resize', checkMobile);
//         return () => window.removeEventListener('resize', checkMobile);
//     }, [breakpoint]);

//     return isMobile;
// };

// --- Main Page Component Template ---
const AWordFromCharles = () => {




    const navbarHeight = '4rem';
    const pageRef = useRef(null); // Create a ref for the page's main container

    // useEffect(() => {
    //     // Scroll to the top of this page's container when the component mounts
    //     // or when the location changes (though here it's on mount since it's a page component)
    //    // if (pageRef.current) {
    //         pageRef.current.scrollTo({ top: 0, behavior: 'smooth' });
    //         console.log('scroll------------------')
    //         // Or, if the main scrollbar is still on `window`:
    //         // window.scrollTo({ top: 0, behavior: 'smooth' });
    //    // }
    // }, []); // Empty dependency array means this runs once on mount



    const location = useLocation();
    useEffect(() => {
        window.scrollTo(100, 0);
    }, [location]); // Run this effect whenever the location changes






    // Styles for main content area (can be customized per page)
    const mainContentAreaStyles = {
        padding: '20px',
        minHeight: '80vh', // Ensure content pushes footer down
        backgroundColor: 'rgba(0, 0, 0, 0.6)', // Example background for content area
        borderRadius: '10px',
        boxShadow: '0 0 20px rgba(0,0,0,0.7)',
        margin: '0rem', // Center the content area
        width: '90%',
        maxWidth: '900px',
        color: colors.textColor,
        textAlign: 'center', // Default text alignment for content
    };















    // Define your override styles as a new JavaScript object
    const overrideParagraphStyles = {
        fontSize: '1rem', // Your desired new font size (overrides 1.3rem from introSubHeadingStyles)
        fontFamily: 'orbitron_medium', // Your desired new font family (overrides whatever was there)
        textAlign: 'center',
        // Add any other specific overrides here
        //fontWeight: 'bold', // Example of another override
        //color: colors.accentColor, // Example of changing color

        // boxShadow: `0px 2px 10px ${colors.cardBorder}20`,
        // margin: '1rem',
        // padding: '0.5rem',
        // border: `1px solid ${colors.accentColor}80`,


    };










    return (

        <PageWrapper navbarPermanent={false}> {/* Home page has fade-in Navbar */}
            {/* Main Project Logo Section */}

            <div style={pageContainerStyles} >
                {/* Navbar: Set initialPermanent to true for a permanent navbar on most pages */}
                <Navbar initialPermanent={true} />

                {/* Spacer for the fixed Navbar */}
                {/* <div style={{ height: navbarHeight }}></div> */}

                {/* --- MAIN PAGE CONTENT AREA --- */}
                <div style={mainContentAreaStyles} ref={pageRef}>
                    {/*
                    *****************************************************
                    * *
                    * PLACE YOUR PAGE-SPECIFIC CONTENT HERE           *
                    * *
                    * You can use headings, paragraphs, lists,        *
                    * images, or other custom components.             *
                    * *
                    *****************************************************
                */}



                    {/* <SocialLinksBar></SocialLinksBar> */}
                    <h1


                        style={{
                            ...introHeadingStyles,
                            marginTop: '2rem',
                        }}

                    >DR. ROBERT GODDARD</h1>
                    <div >
                        <p

                            style={{
                                ...introSubHeadingStyles, // Apply the base styles first
                                ...overrideParagraphStyles,
                                marginBottom: '3rem', // Then apply your overrides (they will win)
                            }}

                        >
                            FATHER OF MODERN ROCKETRY

                        </p>
                    </div>

                    <img
                        src={GODDARD_ROCKET_LAB}
                        alt="GODDARD_ROCKET_LAB"
                        style={{
                            width: 'auto',
                            height: 'auto', // Fixed height for the image
                            margin: '0rem', // Remove any default margins
                            borderRadius: '3rem',
                            // Add responsive image sizing if needed
                            maxWidth: '100%', // Ensure image doesn't overflow its container
                            //objectFit: 'cover', // Or 'contain' depending on desired behavior

                            //boxShadow: `4px 4px 6px ${colors.accentColor}70`,
                            boxShadow: `0px 0px 10px 4px ${colors.accentColor}90`, // Example: Centered, very blurry, slightly spread, more opaque

                            border: `1px solid ${colors.accentColor}80`,
                            marginBottom: '2rem',
                        }}


                    />

























                    <Box
                        sx={{
                            display: 'flex',
                            justifyContent: 'center',
                            // --- KEY CHANGE: Responsive flexDirection ---
                            flexDirection: { xs: 'column', md: 'row' }, // Stack on extra-small (mobile), row on medium (desktop) and up
                            // Add gap for spacing between image and text
                            gap: { xs: '1rem', md: '2rem' }, // Gap when stacked vs side-by-side
                            alignItems: 'center', // Center items when stacked or in a row
                            width: '100%', // Ensure it takes full width
                            maxWidth: '900px', // Limit overall width
                            margin: '2rem auto', // Center the whole section
                        }}
                    >
                        {/* Image Column/Row Item */}
                        <Box
                            sx={{
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center', // Center image vertically if it doesn't take full height
                                flexShrink: 0, // Prevent image container from shrinking
                                // No need for flexDirection:'column' here unless you have multiple items inside this box
                            }}
                        >
                            <img
                                src={ROBERT_GODDARD_STANDING_ROCKET}
                                alt="ROBERT_GODDARD_STANDING_ROCKET"
                                style={{
                                    width: 'auto',
                                    height: '20rem', // Fixed height for the image
                                    margin: '0rem', // Remove any default margins
                                    borderRadius: '50%',
                                    // Add responsive image sizing if needed
                                    maxWidth: '100%', // Ensure image doesn't overflow its container
                                    objectFit: 'cover', // Or 'contain' depending on desired behavior
                                    boxShadow: `0px 0px 10px 4px ${colors.accentColor}90`, // Example: Centered, very blurry, slightly spread, more opaque
                                    border: `1px solid ${colors.accentColor}80`,
                                }}


                            />
                        </Box>



                        <Box
                            sx={{
                                margin: { xs: '1rem 0', md: '0 2rem' }, // Adjust margin for stacked vs. side-by-side
                                textAlign: 'left',
                                flexGrow: 1, // Allow text content to take available space
                                maxWidth: { xs: '90%', md: '500px' }, // Limit text width for readability
                            }}
                        >
                            <p>
                                Goddard’s story is an inspirational one of vision, perseverance, discipline, and focus in pursuit of the dream of space exploration.
                            </p>
                            <p>
                                His advanced theories were so groundbreaking and ahead of his times that they were mocked and ridiculed by colleagues and even The New York Times.
                            </p>
                            <p>
                                Yet he persisted, and with minimal resources, overcame adversity and ultimately launched the world’s first liquid-fueled rocket, ushering in the space age.
                            </p>
                        </Box>



                    </Box>













































                    <div>

                        <img
                            src={IMG_03}
                            alt="IMG_03"
                            style={{
                                width: 'auto',
                                height: '8rem', // Fixed height for the image
                                margin: '1rem', // Remove any default margins
                                borderRadius: '50%',
                                maxWidth: '100%', // Ensure image doesn't overflow its container
                                objectFit: 'cover', // Or 'contain' depending on desired behavior

                                boxShadow: `0px 0px 10px 4px ${colors.accentColor}90`, // Example: 
                                border: `1px solid ${colors.accentColor}80`,
                            }}
                        />


                        <img
                            src={IMG_04}
                            alt="IMG_04"
                            style={{
                                width: 'auto',
                                height: '8rem', // Fixed height for the image
                                margin: '1rem', // Remove any default margins
                                borderRadius: '50%',
                                maxWidth: '100%', // Ensure image doesn't overflow its container
                                objectFit: 'cover', // Or 'contain' depending on desired behavior

                                boxShadow: `0px 0px 10px 4px ${colors.accentColor}90`, // Example: 
                                border: `1px solid ${colors.accentColor}80`,
                            }}
                        />



                        <img
                            src={IMG_05}
                            alt="IMG_05"
                            style={{
                                width: 'auto',
                                height: '8rem', // Fixed height for the image
                                margin: '1rem', // Remove any default margins
                                borderRadius: '50%',
                                maxWidth: '100%', // Ensure image doesn't overflow its container
                                objectFit: 'cover', // Or 'contain' depending on desired behavior

                                boxShadow: `0px 0px 10px 4px ${colors.accentColor}90`, // Example: 
                                border: `1px solid ${colors.accentColor}80`,
                            }}
                        />



                        <img
                            src={IMG_06}
                            alt="IMG_06"
                            style={{
                                width: 'auto',
                                height: '8rem', // Fixed height for the image
                                margin: '1rem', // Remove any default margins
                                borderRadius: '50%',
                                maxWidth: '100%', // Ensure image doesn't overflow its container
                                objectFit: 'cover', // Or 'contain' depending on desired behavior

                                boxShadow: `0px 0px 10px 4px ${colors.accentColor}90`, // Example: 
                                border: `1px solid ${colors.accentColor}80`,
                            }}
                        />
                    </div>












































                    <div style={{ margin: '2rem' }}>
                        <h1 style={introHeadingStyles}>A TRUE VISIONARY</h1>
                    </div>

                    <Box
                        sx={{
                            display: 'flex',
                            justifyContent: 'center',
                            // --- KEY CHANGE: Responsive flexDirection ---
                            flexDirection: { xs: 'column', md: 'row' }, // Stack on extra-small (mobile), row on medium (desktop) and up
                            // Add gap for spacing between image and text
                            gap: { xs: '1rem', md: '2rem' }, // Gap when stacked vs side-by-side
                            alignItems: 'center', // Center items when stacked or in a row
                            width: '100%', // Ensure it takes full width
                            maxWidth: '900px', // Limit overall width
                            margin: '2rem auto', // Center the whole section
                        }}
                    >
                        {/* Image Column/Row Item */}
                        <Box
                            sx={{
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center', // Center image vertically if it doesn't take full height
                                flexShrink: 0, // Prevent image container from shrinking
                                // No need for flexDirection:'column' here unless you have multiple items inside this box
                            }}
                        >
                            <img
                                src={IMG_14}
                                alt="IMG_14"
                                style={{
                                    width: 'auto',
                                    height: '20rem', // Fixed height for the image
                                    margin: '0rem', // Remove any default margins
                                    borderRadius: '4rem',// '50%',
                                    // Add responsive image sizing if needed
                                    maxWidth: '100%', // Ensure image doesn't overflow its container
                                    objectFit: 'cover', // Or 'contain' depending on desired behavior
                                    boxShadow: `0px 0px 10px 4px ${colors.accentColor}90`, // Example: Centered, very blurry, slightly spread, more opaque
                                    border: `1px solid ${colors.accentColor}80`,
                                }}


                            />
                        </Box>



                        <Box
                            sx={{
                                margin: { xs: '1rem 0', md: '0 2rem' }, // Adjust margin for stacked vs. side-by-side
                                textAlign: 'left',
                                flexGrow: 1, // Allow text content to take available space
                                maxWidth: { xs: '90%', md: '500px' }, // Limit text width for readability
                            }}
                        >
                            <li className="ul_li_more_spacing">
                                In the 1920's, Goddard experimented with electric ion propulsion and wrote articles on interstellar migration, multi-stage rockets, and suspended animation for long-term space exploration.
                            </li>
                            <li className="ul_li_more_spacing">
                                Goddard designed prototypes for high-speed vacuum trains to connect cities. He did considerable research in solar power to be used for space travel and inexpensive terrestrial power.
                            </li>
                            <li className="ul_li_more_spacing">
                                In 1899, at age 17, while sitting in his favorite cherry tree and gazing at stars, Goddard envisioned the possibility of space travel to Mars and beyond. He forever called it his “Anniversary Day.”

                            </li>

                            <li className="ul_li_more_spacing">
                                In his essay, “A Cherry Tree to Mars,” the astronomer Carl Sagan noted that the origin of the Mars Viking spacecraft could be traced back to the vision of a young Robert Goddard, in Worcester, MA.
                            </li>


                        </Box>



                    </Box>





































                    <div>

                        <img
                            src={IMG_07}
                            alt="IMG_07"
                            style={{
                                width: 'auto',
                                height: '8rem', // Fixed height for the image
                                margin: '1rem', // Remove any default margins
                                borderRadius: '50%',
                                maxWidth: '100%', // Ensure image doesn't overflow its container
                                objectFit: 'cover', // Or 'contain' depending on desired behavior

                                boxShadow: `0px 0px 10px 4px ${colors.accentColor}90`, // Example: 
                                border: `1px solid ${colors.accentColor}80`,
                            }}
                        />


                        <img
                            src={IMG_08}
                            alt="IMG_08"
                            style={{
                                width: 'auto',
                                height: '8rem', // Fixed height for the image
                                margin: '1rem', // Remove any default margins
                                borderRadius: '50%',
                                maxWidth: '100%', // Ensure image doesn't overflow its container
                                objectFit: 'cover', // Or 'contain' depending on desired behavior

                                boxShadow: `0px 0px 10px 4px ${colors.accentColor}90`, // Example: 
                                border: `1px solid ${colors.accentColor}80`,
                            }}
                        />



                        <img
                            src={IMG_09}
                            alt="IMG_09"
                            style={{
                                width: 'auto',
                                height: '8rem', // Fixed height for the image
                                margin: '1rem', // Remove any default margins
                                borderRadius: '50%',
                                maxWidth: '100%', // Ensure image doesn't overflow its container
                                objectFit: 'cover', // Or 'contain' depending on desired behavior

                                boxShadow: `0px 0px 10px 4px ${colors.accentColor}90`, // Example: 
                                border: `1px solid ${colors.accentColor}80`,
                            }}
                        />



                        <img
                            src={IMG_10}
                            alt="IMG_10"
                            style={{
                                width: 'auto',
                                height: '8rem', // Fixed height for the image
                                margin: '1rem', // Remove any default margins
                                borderRadius: '50%',
                                maxWidth: '100%', // Ensure image doesn't overflow its container
                                objectFit: 'cover', // Or 'contain' depending on desired behavior

                                boxShadow: `0px 0px 10px 4px ${colors.accentColor}90`, // Example: 
                                border: `1px solid ${colors.accentColor}80`,
                            }}
                        />
                    </div>

























                    <div style={{ margin: '2rem' }}>
                        <h1 style={introHeadingStyles}>LEVERAGING THE LEGACY...</h1>
                    </div>
                    <div >
                        <p

                            style={{
                                ...introSubHeadingStyles, // Apply the base styles first
                                ...overrideParagraphStyles, // Then apply your overrides (they will win)
                            }}

                        >
                            ...OF "THE FATHER OF MODERN ROCKETRY"

                        </p>
                    </div>
                    <Box
                        sx={{
                            display: 'flex',
                            justifyContent: 'center',
                            // --- KEY CHANGE: Responsive flexDirection ---
                            flexDirection: { xs: 'column', md: 'row' }, // Stack on extra-small (mobile), row on medium (desktop) and up
                            // Add gap for spacing between image and text
                            gap: { xs: '1rem', md: '2rem' }, // Gap when stacked vs side-by-side
                            alignItems: 'center', // Center items when stacked or in a row
                            width: '100%', // Ensure it takes full width
                            maxWidth: '900px', // Limit overall width
                            margin: '2rem auto', // Center the whole section
                        }}
                    >
                        {/* Image Column/Row Item */}
                        <Box
                            sx={{
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center', // Center image vertically if it doesn't take full height
                                flexShrink: 0, // Prevent image container from shrinking
                                // No need for flexDirection:'column' here unless you have multiple items inside this box
                            }}
                        >
                            <img
                                src={IMG_05}
                                alt="IMG_05"
                                style={{
                                    width: 'auto',
                                    height: '20rem', // Fixed height for the image
                                    margin: '0rem', // Remove any default margins
                                    borderRadius: '50%',
                                    // Add responsive image sizing if needed
                                    maxWidth: '100%', // Ensure image doesn't overflow its container
                                    objectFit: 'cover', // Or 'contain' depending on desired behavior
                                    boxShadow: `0px 0px 10px 4px ${colors.accentColor}90`, // Example: Centered, very blurry, slightly spread, more opaque
                                    border: `1px solid ${colors.accentColor}80`,
                                }}


                            />
                        </Box>



                        <Box
                            sx={{
                                margin: { xs: '1rem 0', md: '0 2rem' }, // Adjust margin for stacked vs. side-by-side
                                textAlign: 'left',
                                flexGrow: 1, // Allow text content to take available space
                                maxWidth: { xs: '90%', md: '500px' }, // Limit text width for readability
                            }}
                        >
                            <li className="ul_li_more_spacing">
                                Today, NASA’s James Webb telescope, the most powerful space telescope ever built, fundamentally alters our understanding of the universe.

                            </li>
                            <li className="ul_li_more_spacing">
                                But did you know it was designed and assembled at NASA’s GODDARD Space Flight Center?

                            </li>
                            <li className="ul_li_more_spacing">
                                Although revered by the scientific and aerospace communities, most people have no clue who Goddard is or the extent of his groundbreaking accomplishments and vision.

                            </li>

                            <li className="ul_li_more_spacing">
                                The Goddard Project aims to reimagine Goddard’s legacy with advanced storytelling technologies, to help inspire and motivate a new generation of dreamers and “visioneers”… “The Mars  Generation.”
                            </li>
                        </Box>



                    </Box>







































                    <div>

                        <img
                            src={IMG_11}
                            alt="IMG_11"
                            style={{
                                width: 'auto',
                                height: '8rem', // Fixed height for the image
                                margin: '1rem', // Remove any default margins
                                borderRadius: '50%',
                                maxWidth: '100%', // Ensure image doesn't overflow its container
                                objectFit: 'cover', // Or 'contain' depending on desired behavior

                                boxShadow: `0px 0px 10px 4px ${colors.accentColor}90`, // Example: 
                                border: `1px solid ${colors.accentColor}80`,
                            }}
                        />


                        <img
                            src={IMG_12}
                            alt="IMG_12"
                            style={{
                                width: 'auto',
                                height: '8rem', // Fixed height for the image
                                margin: '1rem', // Remove any default margins
                                borderRadius: '50%',
                                maxWidth: '100%', // Ensure image doesn't overflow its container
                                objectFit: 'cover', // Or 'contain' depending on desired behavior

                                boxShadow: `0px 0px 10px 4px ${colors.accentColor}90`, // Example: 
                                border: `1px solid ${colors.accentColor}80`,
                            }}
                        />



                        {/* <img
                            src={IMG_13}
                            alt="IMG_13"
                            style={{
                                width: 'auto',
                                height: '8rem', // Fixed height for the image
                                margin: '1rem', // Remove any default margins
                                borderRadius: '50%',
                                maxWidth: '100%', // Ensure image doesn't overflow its container
                                objectFit: 'cover', // Or 'contain' depending on desired behavior

                                boxShadow: `0px 0px 10px 4px ${colors.accentColor}90`, // Example: 
                                border: `1px solid ${colors.accentColor}80`,
                            }}
                        /> */}


                    </div>

















































                    <div style={{ margin: '2rem' }}>
                        <h1 style={introHeadingStyles}>ANYTHING IS POSSIBLE!</h1>
                    </div>

                    <Box
                        sx={{
                            display: 'flex',
                            justifyContent: 'center',
                            // --- KEY CHANGE: Responsive flexDirection ---
                            flexDirection: { xs: 'column', md: 'row' }, // Stack on extra-small (mobile), row on medium (desktop) and up
                            // Add gap for spacing between image and text
                            gap: { xs: '1rem', md: '2rem' }, // Gap when stacked vs side-by-side
                            alignItems: 'center', // Center items when stacked or in a row
                            width: '100%', // Ensure it takes full width
                            maxWidth: '900px', // Limit overall width
                            margin: '2rem auto', // Center the whole section
                        }}
                    >
                        {/* Image Column/Row Item */}
                        <Box
                            sx={{
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center', // Center image vertically if it doesn't take full height
                                flexShrink: 0, // Prevent image container from shrinking
                                // No need for flexDirection:'column' here unless you have multiple items inside this box
                            }}
                        >
                            <img
                                src={IMG_13}
                                alt="IMG_13"
                                style={{
                                    width: 'auto',
                                    height: '20rem', // Fixed height for the image
                                    margin: '0rem', // Remove any default margins
                                    borderRadius: '50%',
                                    // Add responsive image sizing if needed
                                    maxWidth: '100%', // Ensure image doesn't overflow its container
                                    objectFit: 'cover', // Or 'contain' depending on desired behavior
                                    boxShadow: `0px 0px 10px 4px ${colors.accentColor}90`, // Example: Centered, very blurry, slightly spread, more opaque
                                    border: `1px solid ${colors.accentColor}80`,
                                }}


                            />
                        </Box>



                        <Box
                            sx={{
                                margin: { xs: '1rem 0', md: '0 2rem' }, // Adjust margin for stacked vs. side-by-side
                                textAlign: 'left',
                                flexGrow: 1, // Allow text content to take available space
                                maxWidth: { xs: '90%', md: '500px' }, // Limit text width for readability
                            }}
                        >
                            <p>
                                In 1903, with their “First Flight,” the Wright brothers got humanity off the ground.
                            </p>
                            <p>
                                Just 23 years later, Dr. Robert Goddard’s “First Launch”, was the first step in taking humankind off the planet.

                            </p>
                            <p>
                                43 years later, on July 20, 1969... We first walked on the Moon!
                            </p>

                            {/* 43 years later, in 1969…we walked on the Moon! */}


                            <p>
                                And today, 56 years later, we are actively exploring every planet in our solar system.
                            </p>


                            <p>
                                And the the Voyager space probes, both launched in 1977, have exited the heliosphere and are traveling through interstellar space!
                            </p>

                            {/* https://science.nasa.gov/mission/voyager/where-are-voyager-1-and-voyager-2-now/ */}



                        </Box>



                    </Box>































                </div>


            </div>
        </PageWrapper>
    );
};

export default AWordFromCharles;